// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5269":"fdda06fd","9773":"0e89a52a"}[chunkId] + ".chunk.css";
};